<template>
  <div class="system-map">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
      <el-form-item label="分站：">
        <el-select v-model="placeData[0]" :disabled="dis[0]" clearable @change="remoteMethod($event,1)" placeholder="省">
          <el-option v-for="o in province" :key="o.id" :label="o.name" :value="o.id"> </el-option>
        </el-select>
        <el-select v-model="placeData[1]" :disabled="dis[1]" clearable @change="remoteMethod($event,2)" placeholder="市">
          <el-option v-for="o in city" :key="o.id" :label="o.name" :value="o.id"> </el-option>
        </el-select><br />
        <el-select v-model="placeData[2]" :disabled="dis[2]" clearable @change="remoteMethod($event,3)" placeholder="县">
          <el-option v-for="o in county" :key="o.id" :label="o.name" :value="o.id"> </el-option>
        </el-select>
        <el-select style="margin:10px 0 0 0" v-model="placeData[3]" :disabled="dis[3]" clearable @change="remoteMethod($event,4)" placeholder="镇">
          <el-option v-for="o in town" :key="o.id" :label="o.name" :value="o.id"> </el-option>
        </el-select><br />
        <el-select style="margin:10px 0 0 0" v-model="placeData[4]" :disabled="dis[4]" clearable @change="remoteMethod($event,5)" placeholder="村">
          <el-option v-for="o in village" :key="o.id" :label="o.name" :value="o.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地图图片：">
        <div class="shangchuan">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="总人口：" prop="totalPersons">
        <el-input v-model.number="ruleForm.totalPersons" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="贫困劳动力：" prop="poorTotalPersons">
        <el-input v-model.number="ruleForm.poorTotalPersons" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="已脱贫：" prop="poorLaborTotalPersons">
        <el-input v-model.number="ruleForm.poorLaborTotalPersons" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="未脱贫：" prop="lostPoorLaborPersons">
        <el-input v-model.number="ruleForm.lostPoorLaborPersons" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="城市信息介绍：" prop="showDesc">
        <el-input style="width:400px" type="textarea" v-model="ruleForm.showDesc" :rows="8"></el-input>
      </el-form-item>
      <el-form-item label="提交：">
        <el-button type="primary" @click="submit()">提&nbsp;&nbsp;&nbsp;交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios'
import mixin_area from '@/Mixins/mixin_area'
export default {
  mixins: [ mixin_area ],
  data() {
    return {
      uploadUrl:`${this.$api.imgUrl}/user/area/show/img`,
      imageUrl: '',
      imgId:'',
      ruleForm:{
        totalPersons : '',
        poorTotalPersons  : '',
        poorLaborTotalPersons : '',
        lostPoorLaborPersons : '',
        showDesc:'',
        id:'',
      },
      rules:{
        totalPersons:[{required: true, message: '请输入总人数', trigger: 'blur' }],
        poorTotalPersons:[{required: true, message: '请输入贫困总人口', trigger: 'blur' }],
        poorLaborTotalPersons:[{required: true, message: '请输入贫困劳动力', trigger: 'blur' }],
        lostPoorLaborPersons:[{required: true, message: '请输入已脱贫人数', trigger: 'blur' }],
        showDesc:[{required: true, message: '请输入描述信息', trigger: 'blur' }],
      },
      province:[],
      city:[],
      county:[],
      town:[],
      village:[],
      placeData:[
        {areaId:''},
        {areaId:''},
        {areaId:''},
        {areaId:''},
        {areaId:''}  
      ],
      admin:false,
      dis:[],
      levelArea:'',
    }
  },
  methods:{
    handleAvatarSuccess(res, file) {
      this.imgId = res.data
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG、PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    getLevel() {
      this.$api.getPlaceName({areaId:this.userInfo.areaId}).then(res =>{
        if (res.data.status == 0) {
          let area = JSON.parse(res.data.data)
          this.levelArea = area.level
        } else {
          this._status(res.data)
        }
      })  
    },
    // 清空下级
    remoteMethod(value,num) {
      switch(num) {
        case 1: this.placeData[1] = this.placeData[2] = this.placeData[3] = this.placeData[4] = ''; break;
        case 2: this.placeData[2] = this.placeData[3] = this.placeData[4] = ''; break;
        case 3: this.placeData[3] = this.placeData[4] = ''; break;
        case 4: this.placeData[4] = ''; break;
      }
      this.areaGet({value: {areaId:value},key:num})
      // this.admin ? '':this.getData1(value)
      if (!this.admin) {
        if (num > this.levelArea) {
          let place = []
          //过滤空字符串
          place = this.placeData.filter(x => x )
          // console.log(num,place)
          value == '' || undefined ?this.getData1(place[num-2]) : this.getData1(value)
        }
      }
    },
    submit() {
      let vm = this
      let place = []
      //过滤空字符串
      place = this.placeData.filter(x => x)
      // vm.admin?console.log(vm.admin):place.push({areaId:vm.userInfo.areaId});
      console.log(place);
      
      this.$refs['ruleForm'].validate((valid) =>{
        if (valid) {
          if (place.length == 0) {
            vm.$message.info('请至少选择一个地区')
          } else if (vm.imgId === '') {
            vm.$message.info('请上传图片')
          } else {
            vm.ruleForm.id = place[place.length-1]
            axios
              .all([
                vm.$api.setDesc({showDesc:vm.ruleForm.showDesc,id:vm.ruleForm.id}),
                vm.$api.setMapInfo(vm.ruleForm),
                vm.$api.setMapImg({showImgId:vm.imgId,id:vm.ruleForm.id})
              ])
              .then(axios.spread(function (acct, perms,res) {
                acct.data.status == 0 && perms.data.status == 0 && res.data.status == 0
                  ? vm.$message.success('上传成功！')
                  :vm.$message.error('上传失败！请检查参数');
              }))
              .catch(function (error1,error2,error3) {
                vm.$message.error('上传失败！请检查参数')
              })
          }
        } else {
          return false
        }
      })
    },
    getData() {
      if (!this.userInfo.admin) {
        this.$api.getSystem(this.userInfo.areaId).then(res =>{
          let response = JSON.parse(res.data.data)
          if (res.data.status === 0) {
            this.ruleForm.totalPersons = response.totalPersons;
            this.ruleForm.poorTotalPersons  = response.poorTotalPersons;
            this.ruleForm.poorLaborTotalPersons = response.poorLaborTotalPersons;
            this.ruleForm.lostPoorLaborPersons = response.lostPoorLaborPersons;
            this.ruleForm.showDesc = response.showDesc
            this.imageUrl = `${this.$api.imgUrl}/user/img/${response.showImgId}`
            this.imgId = response.showImgId
          } else {
            this._status(res.data)
          }
        })
      }
    },
    getData1(data) {
      this.$api.getSystem(data).then(res =>{
        let response = JSON.parse(res.data.data)
        if (res.data.status === 0) {
            this.ruleForm.totalPersons = response.totalPersons;
            this.ruleForm.poorTotalPersons  = response.poorTotalPersons;
            this.ruleForm.poorLaborTotalPersons = response.poorLaborTotalPersons;
            this.ruleForm.lostPoorLaborPersons = response.lostPoorLaborPersons;
            this.ruleForm.showDesc = response.showDesc
            this.imageUrl = `${this.$api.imgUrl}/user/img/${response.showImgId}`
            this.imgId = response.showImgId
        } else {
          this._status(res.data)
        }
      })
    },
    
    //设置默认地址
    getDefault() {
      if (this.userInfo.admin) {
        for (let index = 0; index < 5; index++) {
          this.dis.push(false)
        }
      } else {
        this.$api.getFather({areaId:this.userInfo.areaId}).then(res => {
          if (res.data.status === 0) {    
            let response = JSON.parse(res.data.data)
            console.log(response);
            
            response.forEach((x,i) => {
              this.areaGet({value:{areaId:x.id},key:i+1})
              // this.placeData.push({areaId:x.id})
              i === 5 ? this.dis.push(false) : this.dis.push(true);
              switch(x.level) {
                case 0 : this.placeData[0]= x.id;break;
                case 1 : this.placeData[1]= x.id;break;
                case 2 : this.placeData[2]= x.id;break;
                case 3 : this.placeData[3]= x.id;break;
                case 4 : this.placeData[4]= x.id;break;
                default : break;
              }
            })
          } else {
            this._status(res.data)
          }
        })
      }
    },
  },
  created() {
    this.areaGet({value:{areaId:0},key:0})
    this.getData()
    this.admin = this.userInfo.admin
    this.admin? '':(this.getDefault(),this.getLevel());
  }
}
</script>

<style scoped>
.system-map{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
 .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}
.avatar {
  width: 300px;
  height: 180px;
  display: block;
}

.el-textarea .el-textarea__inner{
  resize: none!important;
}
.shangchuan{
  border: 1px dashed #d9d9d9 !important;
  width: 300px;
  height: 180px;
}
</style>
